import { ReactNode } from 'react';

/**
 * flattened array of highlight spans (start/end pairs)
 */
export type HighlightRangePairs = number[] & { __brand: 'uFuzzyHighlightRangePairs' };

type Highlighter = (text: string, ranges: HighlightRangePairs | null) => ReactNode;
export function buildHighlighter(highlight: (text: string) => ReactNode): Highlighter {
    return (text, ranges) => {
        if (!ranges || ranges.length === 0) {
            return text;
        }
        const parts: ReactNode[] = [];

        let cursor = 0;
        for (let i = 0; i < ranges.length; i += 2) {
            const start = ranges[i];
            const end = ranges[i + 1];
            if (cursor < start) {
                parts.push(text.slice(cursor, start));
            }
            parts.push(highlight(text.slice(start, end)));
            cursor = end;
        }
        if (cursor < text.length) {
            parts.push(text.slice(cursor));
        }

        return <span>{parts}</span>;
    };
}
